
import { Section } from "./data-types";

export const AboutCurrentCommittee: {
	sections: (Section | (() => JSX.Element))[];
} = {
	sections: [
		{
			type: "cards",
			options: {
				columns: 1,
			},
			items: [
				{
					type: "CardItem",
					options: {
						// span: "max"
						align: "left"
					},
					data: {
						title: "Current Committee",
						content: () => [
							<h3>President: </h3>,
							<p><a href="https://people.ucd.ie/karen.keaveney">Dr Karen Keaveney</a>, University College Dublin</p>,
							<h3>Vice-President:</h3>,
							<p><a href="https://people.ucd.ie/arlene.crampsie/about">Dr Arlene Crampsie</a>, University College Dublin</p>,
							<h3>Secretary:</h3>,
							<p><a href="https://www.dcu.ie/historygeography/people/jonathan-cherry">Dr Jonathan Cherry</a>, Dublin City University</p>,
							<h3>Treasurer:</h3>,
							<p><a href="https://www.linkedin.com/in/dominic-robinson-393695b6/">Dominic Robinson</a>, University College Dublin</p>,
							<h3>Membership Officer:</h3>,
							<p><a href="https://www.maynoothuniversity.ie/people/louise-sarsfield-collins">Dr Louise Sarsfield Collins</a>, Maynooth University</p>,
							<h3>Editor, Irish Geography:</h3>,
							<p><a href="https://people.ucd.ie/gerald.mills">Prof. Gerald Mills</a>, University College Dublin</p>,
							<h3>Business Manager, Irish Geography:</h3>,
							<p><a href="https://www.maynoothuniversity.ie/people/mary-gilmartin">Prof. Mary Gilmartin,</a> Maynooth University</p>,
							<h3>PRO (Public Relations Officer):</h3>,
							<p><a href="https://www.nuigalway.ie/our-research/people/geography-and-archaeology/kathyreilly/">Dr Kathy Reilly</a>, NUI Galway</p>,
							<h3>Website and Social Media Officer:</h3>,
							<p><a href="https://www.linkedin.com/in/shirleyahowe/">Dr Shirley Howe</a>, Maynooth University</p>,
							<h3>PECN Representative:</h3>,
							<p>Alexia O&#39;Brien, Trinity College Dublin</p>,
							<h3>Ordinary Committee Members:</h3>,
							<p><a href="https://www.universityofgalway.ie/our-research/people/geography-and-archaeology/francesfahy/">Prof. Frances Fahy</a>, University of Galway (RIA Liaison)</p>,
							<p><a href="https://pure.qub.ac.uk/en/persons/niall-majury">Dr Niall Majury</a>, Queen&#39;s University Belfast</p>,
							<p><a href="https://lit.ie/en-IE/Staff/Staff-Directory/Dr-Shane-O-Sullivan">Dr Shane O&#39;Sullivan</a>, TU of the Shannon</p>,
							<p><a href="https://people.ucd.ie/dean.phelan">Dr Dean Phelan</a>, University College Dublin</p>,
							<p><a href="https://www.maynoothuniversity.ie/faculty-social-sciences/our-people/conor-murphy">Prof. Conor Murphy</a>, Maynooth University</p>,
							<p><a href="https://www.dcu.ie/historygeography/people/ruth-mcmanus">Dr Ruth McManus</a>, Dublin City University</p>,
							<h3>CIG Contact Point:</h3>,
							// <p><a href="https://pure.qub.ac.uk/en/persons/keith-lilley">Prof Keith Lilley</a> / <a href="https://pure.qub.ac.uk/en/persons/estelle-lowry">Dr Estelle Lowry</a>, QUB, CIG 2025</p>,
							<p><a href="https://research.ucc.ie/profiles/kieran.hickey@ucc.ie">Dr Kieran Hickey</a>, UCC, CIG 2026</p>
						]
					},
				},
				// {
				// 	type: "CardImage",
				// 	options: {
				// 	},
				// 	data: {
				// 		media: {
				// 			type: "image",
				// 			src: "/images/examples/1.jpg"
				// 		},
				// 	},
				// }
			]
		}
	]
}
